export { default, default as ShareResourcesModal } from "./ShareResourcesModal";
